import type { Action } from './actions';

/** Device-neutral description of a press, built from DOM events by dom-input.ts. */
export type InputEventLike =
  | { kind: 'keydown'; code: string; repeat: boolean }
  | { kind: 'keyup'; code: string }
  | { kind: 'pointerdown'; pointerType: string; button: number; target: 'canvas' | 'ui' }
  | { kind: 'pointerup'; pointerType: string; button: number; target: 'canvas' | 'ui' };

/** Keys by physical position (KeyboardEvent.code), GDD §5.5. No key remapping in the MVP. */
const KEY_ACTIONS: Readonly<Record<string, Action>> = {
  Space: 'FLAP',
  KeyW: 'FLAP',
  ArrowUp: 'FLAP',
  Escape: 'PAUSE',
  KeyP: 'PAUSE',
};

/**
 * Maps a press to an action, or null. Flaps register on press only, never on release or key
 * auto-repeat, and only on the game canvas: presses on the interface belong to the interface.
 */
export function mapInput(event: InputEventLike): Action | null {
  switch (event.kind) {
    case 'keydown':
      return event.repeat ? null : (KEY_ACTIONS[event.code] ?? null);
    case 'pointerdown': {
      if (event.target !== 'canvas') return null;
      const primary = event.pointerType === 'mouse' ? event.button === 0 : true;
      return primary ? 'FLAP' : null;
    }
    default:
      return null;
  }
}
